import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import { FaQuoteLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
function Feedback(){ 
    const scrollRef = useRef(null);

    const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    const scrollAmount = 320;

    el.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: "smooth",
    });
    };
    const tagTestimonials = [
        {
            text: "I started noticing the same customers coming back without me calling or following up. It felt like the system understands when they are ready to buy again.",
            name: "Wanjiku",
            color: "#FFD700",
        },
        {
            text: "I used to guess who my best customers are. Now I know exactly who buys often and what they like, and they keep coming back more consistently.",
            name: "James",
            color: "#6A0DAD",
        },
        {
            text: "My customers don’t feel like they are being marketed to. The messages feel natural and personal, and that is what is making them come back.",
            name: "Fatma",
            color: "#FF6B6B",
        },
        {
            text: "Before this, I would just sell and wait. Now I can see who is likely to return and I reach them at the right time with the right message.",
            name: "BrianK",
            color: "#00C8FF",
        },
        {
            text: "Sales are no longer random. I can actually track repeat customers and see steady growth from people who have already bought before.",
            name: "Zainab",
            color: "#00D26A",
        },
        {
            text: "The way it connects payments to customers changed everything for me. I now understand buying patterns and use that to bring customers back again.",
            name: "Elsie W.",
            color: "#FF1493",
        },
        {
            text: "It feels like I finally have a system that keeps relationships going. Customers return more often because the engagement feels real, not forced.",
            name: "Samuel",
            color: "#40E0D0",
        }
    ]; 

    return (
        <>                    
            <div className="col-12 mt-5 mb-2 pt-6indx0">
                <div className="container">

                    {/* HEADER + CONTROLS */}
                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <h1 className="mb-5 mw700 fw800">
                            <b>
                                What business owners {" "}
                                <span className="bg-gold-yellow">are saying.</span>
                            </b>
                        </h1>

                        {/* 🔹 SCROLL ARROWS */}
                        <div className="d-flex gap-2">
                        <button className="scroll-btn" onClick={() => scroll('left')}>
                            <ArrowLeft size={18} className="mb-2"/>
                        </button>
                        <button className="scroll-btn" onClick={() => scroll('right')}>
                            <ArrowRight size={18} className="mb-2"/>
                        </button>
                        </div>
                    </div>

                    {/* 🔥 SCROLL ROW */}
                    <div className="testimonial-scroll-wrapper">
                        <div 
                            ref={scrollRef} 
                            className="d-flex flex-nowrap overflow-auto usecase-scroll pb-4"
                            style={{ gap: "16px" }}
                        >
                            {tagTestimonials.map((item, index) => (
                            
                            <div 
                                key={index} 
                                className="flex-shrink-0"
                                style={{ width: "300px" }}
                            >

                                <div className="testimonial-card p-4 h-100">

                                {/* QUOTE */}
                                <div className="quote-icon mb-3"><FaQuoteLeft/></div>

                                {/* TEXT */}
                                <p className="testimonial-text mb-4 text-left">
                                    {item.text}
                                </p>

                                {/* USER */}
                                <div className="d-flex align-items-center">

                                    <div 
                                    className="avatar me-2"
                                    style={{ backgroundColor: item.color }}
                                    >
                                    {item.name
                                        .split(' ')
                                        .map((n) => n[0])
                                        .join('')}
                                    </div>

                                    <div>
                                    <div className="font9"><b>{item.name}</b></div>
                                    <div className="font8 text-muted">@{item.name.replace(/\s/g, '').toLowerCase()}</div>
                                    </div>

                                </div>

                                </div>

                            </div>

                            ))}
                        </div>
                    </div>        
                </div>
            </div>  
        </>
    )
}

export default Feedback;
